// extracted by mini-css-extract-plugin
module.exports = {"content":"_1Z97LB","contentItem":"_2OqRLq","layout":"_2MWxNV","sidebar":"qMf8i6","summary":"_29eVKe"};